module.exports = __webpack_public_path__ + "static/media/first.a1573c6a.svg";